module.exports = __webpack_public_path__ + "media/images/ui__arrowDown--dark-22a94f6ba5d873fbb14b61407fafbdca.png";